module.exports = __webpack_public_path__ + "img/ATRC Platform - Website TCs-11.f9e7580e.png";